import React from "react";

/**
 * Question Renderer Component
 * Renders different question types: text, single choice, multi choice, rating scale
 */
const QuestionRenderer = ({ question, value, onChange, disabled }) => {
  const questionType = question.type || question.questionType;
  const options = question.options || [];
  const ratingConfig = question.ratingConfig || { min: 1, max: 5 };

  switch (questionType) {
    case "text_short":
      return (
        <input
          type="text"
          className="diag-input"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter your answer..."
          disabled={disabled}
          maxLength={250}
        />
      );

    case "text_long":
      return (
        <textarea
          className="diag-textarea"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter your answer..."
          disabled={disabled}
          rows={4}
        />
      );

    case "single_choice":
      return (
        <div className="diag-options">
          {options.map((opt, idx) => (
            <label key={idx} className="diag-option">
              <input
                type="radio"
                name={`q-${question._id || idx}`}
                value={opt.value}
                checked={value === opt.value}
                onChange={() => onChange(opt.value, opt.label)}
                disabled={disabled}
              />
              <span className="diag-option-label">{opt.label}</span>
            </label>
          ))}
        </div>
      );

    case "multi_choice":
      const selectedValues = Array.isArray(value) ? value : [];
      return (
        <div className="diag-options">
          {options.map((opt, idx) => (
            <label key={idx} className="diag-option">
              <input
                type="checkbox"
                value={opt.value}
                checked={selectedValues.includes(opt.value)}
                onChange={(e) => {
                  const newValues = e.target.checked
                    ? [...selectedValues, opt.value]
                    : selectedValues.filter((v) => v !== opt.value);
                  const newLabels = options
                    .filter((o) => newValues.includes(o.value))
                    .map((o) => o.label);
                  onChange(newValues, null, newLabels);
                }}
                disabled={disabled}
              />
              <span className="diag-option-label">{opt.label}</span>
            </label>
          ))}
        </div>
      );

    case "rating_scale":
      const { minLabel, maxLabel } = ratingConfig;
      const likertOptions = [
        { value: 1, label: "Never", shade: "shade-1" },
        { value: 2, label: "Rarely", shade: "shade-2" },
        { value: 3, label: "Occasionally", shade: "shade-3" },
        { value: 4, label: "Frequently", shade: "shade-4" },
        { value: 5, label: "Very Frequently", shade: "shade-5" },
      ];
      return (
        <div className="likert-container">
          <div className="likert-row">
            {likertOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                className={`likert ${opt.shade} ${value === opt.value ? "active" : ""}`}
                onClick={() => onChange(opt.value)}
                disabled={disabled}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <div className="likert-legend">
            <span>{minLabel || ""}</span>
            <span>{maxLabel || ""}</span>
          </div>
        </div>
      );

    default:
      return (
        <input
          type="text"
          className="diag-input"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
      );
  }
};

export default QuestionRenderer;
